import { render, staticRenderFns } from "./list.vue?vue&type=template&id=626ebdbc&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=626ebdbc&prod&scoped=true&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=626ebdbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626ebdbc",
  null
  
)

export default component.exports